import React, { memo } from "react";
import { Node } from "@iventis/domain-model/model/node";
import { CustomDialog, CustomDialogAnchor } from "@iventis/components";
import { PermissionsEditForm } from "./permissions-edit-wrappers";

export const PermissionsEditModalComponent: React.FC<{
    node: Node;
    open: boolean;
    close: () => void;
}> = memo(
    ({ node, open, close }) => (
        <CustomDialog anchor={CustomDialogAnchor.TOP} open={open} onClose={close} maxWidth="lg">
            <PermissionsEditForm node={node} close={close} />
        </CustomDialog>
    ),
    (prev, next) => prev.open === next.open
);
